export const latestPunchesLimit = 15;
export const reportTimeFormat = 'MMM Do YYYY, hh:mm A';

const prod = {
    url: {
        BACKEND_URL: "https://tempus2.ddns.net:8080/api"
    },
    auth0: {
        audience: 'https://tempus/',
        domain: "tempus-skydivers.us.auth0.com",
        clientId: "Q0RP1YlW7aihpx5GWzgGXpaanCEaGI9k"
    }
}
const dev = {
    url: {
        BACKEND_URL: "http://localhost:8080/api"
    },
    auth0: {
        audience: 'https://tempus/',
        domain: "dev-izqe1bw6.us.auth0.com",
        clientId: "sajFaqwgqcD6UUZrTzd6f9uXmiGmuE2O"
    }
}

export const config = process.env.REACT_APP_LOCAL_TO_PROD === undefined && process.env.NODE_ENV === "development" ? dev : prod;
